
import { Options, Vue } from 'vue-class-component'

@Options({
  components: {},
})
export default class App extends Vue {
  githush = process.env.VUE_APP_GITHASH?.toString().substring(0, 7)

  created() {
    document.documentElement.setAttribute('lang', 'th')
    console.log(`Githash: ${this.githush}`)
  }
}
